import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  listItem: {
    lineHeight: "0 !important",
    padding: "0px 15px",
    "&:hover": {
      cursor: "pointer",
    },
    "& .MuiTypography-body1": { fontFamily: "SFProText-Regular", fontSize: "14px" },
  },
  linkText: {
    "& .MuiTypography-body1": { fontSize: "14px" },
  },
  List: {
    backgroundColor: theme.palette.bg,
  },
}));

export default useStyles;
